var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShiningstar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_d_3230_1846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5714 8.857C24.3478 8.857 24.1646 8.69257 24.1335 8.45987C23.8261 6.38722 23.5435 6.09867 21.5497 5.87218C21.3199 5.84427 21.1429 5.65189 21.1429 5.42849C21.1429 5.20199 21.3168 5.01584 21.5466 4.98171C23.5279 4.70557 23.7733 4.46356 24.1335 2.39404C24.1739 2.16444 24.3509 2 24.5714 2C24.7981 2 24.9783 2.16444 25.0155 2.39715C25.3168 4.46666 25.5994 4.75521 27.5901 4.98171C27.8261 5.01274 28 5.19891 28 5.42849C28 5.65189 27.8323 5.83806 27.5963 5.87218C25.6118 6.15452 25.3696 6.39343 25.0155 8.46295C24.9689 8.69565 24.7888 8.857 24.5714 8.857Z",
    fill: "url(#paint0_linear_3230_1846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5714 8.857C24.3478 8.857 24.1646 8.69257 24.1335 8.45987C23.8261 6.38722 23.5435 6.09867 21.5497 5.87218C21.3199 5.84427 21.1429 5.65189 21.1429 5.42849C21.1429 5.20199 21.3168 5.01584 21.5466 4.98171C23.5279 4.70557 23.7733 4.46356 24.1335 2.39404C24.1739 2.16444 24.3509 2 24.5714 2C24.7981 2 24.9783 2.16444 25.0155 2.39715C25.3168 4.46666 25.5994 4.75521 27.5901 4.98171C27.8261 5.01274 28 5.19891 28 5.42849C28 5.65189 27.8323 5.83806 27.5963 5.87218C25.6118 6.15452 25.3696 6.39343 25.0155 8.46295C24.9689 8.69565 24.7888 8.857 24.5714 8.857Z",
    stroke: "url(#paint1_linear_3230_1846)",
    strokeWidth: 0.155912
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter1_d_3230_1846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2857 26.1584C13.6149 26.1584 13.0652 25.6651 12.972 24.967C12.0497 18.7491 11.2018 17.8834 5.22048 17.2039C4.53103 17.1202 3.99997 16.5431 3.99997 15.8729C3.99997 15.1934 4.52167 14.6349 5.21112 14.5325C11.1553 13.7041 11.8913 12.9781 12.972 6.76953C13.0932 6.08074 13.6242 5.5874 14.2857 5.5874C14.9658 5.5874 15.5062 6.08074 15.618 6.77884C16.5218 12.9874 17.3696 13.853 23.3417 14.5325C24.0497 14.6256 24.5715 15.1841 24.5715 15.8729C24.5715 16.5431 24.0684 17.1016 23.3603 17.2039C17.4069 18.051 16.6801 18.7677 15.618 24.9763C15.4783 25.6744 14.9379 26.1584 14.2857 26.1584Z",
    fill: "url(#paint2_linear_3230_1846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2857 26.1584C13.6149 26.1584 13.0652 25.6651 12.972 24.967C12.0497 18.7491 11.2018 17.8834 5.22048 17.2039C4.53103 17.1202 3.99997 16.5431 3.99997 15.8729C3.99997 15.1934 4.52167 14.6349 5.21112 14.5325C11.1553 13.7041 11.8913 12.9781 12.972 6.76953C13.0932 6.08074 13.6242 5.5874 14.2857 5.5874C14.9658 5.5874 15.5062 6.08074 15.618 6.77884C16.5218 12.9874 17.3696 13.853 23.3417 14.5325C24.0497 14.6256 24.5715 15.1841 24.5715 15.8729C24.5715 16.5431 24.0684 17.1016 23.3603 17.2039C17.4069 18.051 16.6801 18.7677 15.618 24.9763C15.4783 25.6744 14.9379 26.1584 14.2857 26.1584Z",
    stroke: "url(#paint3_linear_3230_1846)",
    strokeWidth: 0.467737
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3230_1846",
    x: 19.3506,
    y: 0.207625,
    width: 10.4416,
    height: 10.4417,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.857125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.4 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3230_1846"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3230_1846",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3230_1846",
    x: 0.337613,
    y: 1.92502,
    width: 27.8962,
    height: 27.8956,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.71425
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.486275 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3230_1846"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3230_1846",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3230_1846",
    x1: 24.5714,
    y1: 2,
    x2: 24.5714,
    y2: 8.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.404167,
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3230_1846",
    x1: 26.9086,
    y1: 1.37479,
    x2: 21.6076,
    y2: 8.2349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3230_1846",
    x1: 14.2857,
    y1: 5.5874,
    x2: 14.2857,
    y2: 26.1584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.445833,
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3230_1846",
    x1: 21.2973,
    y1: 3.71176,
    x2: 5.39427,
    y2: 24.2922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiningstar);
export default __webpack_public_path__ + "static/media/shiningstar.836e3d8083f1e13aba552f20e0ff82d3.svg";
export { ForwardRef as ReactComponent };